<template>
  <DLoading class="text-xl" />
</template>

<script setup>
import { DLoading } from '@disguise/cloud-ui';
</script>
